import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // const hostname = window.location.hostname;
  // const currentSubdomain = hostname.split('.')[0].toLowerCase();
  // const isMainSite = currentSubdomain === 'www' || currentSubdomain === 'djinfotech' || currentSubdomain === 'localhost';

  // if ((!isMainSite && user.prefix && user.prefix.toLowerCase() !== currentSubdomain) || (isMainSite && user.roleId !== 1)) {
  //   console.error("CRITICAL: Subdomain mismatch! Possible data breach attempt.");
    
  //   // Immediately clear local data and log out
  //   // It is safer to use window.location for a hard refresh here
  //   logout(); 
  //   return <Navigate to="/login?error=unauthorized" replace />;
  // }
  

  return children;
};

export default ProtectedRoute;
